import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isOpenSWW: false,
  countClickVTO: 0,
  countClickNewArrivals: 0,
  countClickCategory: 0,
  countClickCategoryColor: 0,
  countClickStyle: 0,
  countClickColor: 0,
  countClickVolume: 0,
};

const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    setCountClickVTO: (state, action) => {
      state.countClickVTO = action.payload;
    },
    setCountClickNewArrivals: (state, action) => {
      state.countClickNewArrivals = action.payload;
    },
    setCountClickCategory: (state, action) => {
      state.countClickCategory = action.payload;
    },
    setCountClickCategoryColor: (state, action) => {
      state.countClickCategoryColor = action.payload;
    },
    setCountClickStyle: (state, action) => {
      state.countClickStyle = action.payload;
    },
    setCountClickColor: (state, action) => {
      state.countClickColor = action.payload;
    },
    setCountClickVolume: (state, action) => {
      state.countClickVolume = action.payload;
    },
    setIsOpenSWW: (state, action) => {
      state.isOpenSWW = action.payload;
    },
  },
});

export const {
  setIsOpenSWW,
  setCountClickVTO,
  setCountClickNewArrivals,
  setCountClickCategory,
  setCountClickCategoryColor,
  setCountClickStyle,
  setCountClickColor,
  setCountClickVolume,
} = globalSlice.actions;

export default globalSlice.reducer;
